import { useQuery } from "@tanstack/react-query";
import useAxiosPrivate from "./useAxiosPrivate";
import useAuth from "./useAuth";

const useUser = () => {
  const axiosPrivate = useAxiosPrivate();
  const { auth } = useAuth();

  return useQuery({
    queryKey: ["user"],
    queryFn: async () => {
      if (!auth?.user) {
        throw new Error("User not authenticated");
      }
      const response = await axiosPrivate.get(`/users/${auth.user}`);
      return response.data;
    },
    enabled: !!auth?.user,
    staleTime: 86400000, // 1 day
    gcTime: 86400000, // 1 day
    refetchOnWindowFocus: false,
    retry: 1,
  });
};

export default useUser;
